angular.module('unergie.main')
.controller('temporaryConnectionsCtrl', ($scope, $state, $uibModal, BoFeaturesService, ApiAdmin, DataAccess, FilterMapping,
    AlertManager, ModalService, TableGeneratorService, OrganizationService, ErrorCatcher) => {
    $scope.temporaryConnectionsAdmin = BoFeaturesService.isFeatureOn('temporaryConnectionsAdmin')
    $scope.contract_status_mapping = FilterMapping.contractStatus

    $scope.temporaryConnections = {
        show: {},
        refreshing: false,
        columns: {
            'id': { label: 'ID', mode: 'search_operator', mandatory: true },
            'status': { label: 'Statut', mode: 'search_wildcard' },
            'id_category': { label: 'Paquet', mode: 'hidden' },
            'category.name': { label: 'Paquet', mode: 'search_wildcard' },
            'category.organization': { label: 'Organisation', mode: 'search_wildcard', isVisible: $scope.temporaryConnectionsAdmin },
            'category.org.type': { label: `Type d'organisation`, mode: 'search_wildcard', isVisible: $scope.temporaryConnectionsAdmin },
            'category.account.brand': { label: 'Compte', mode: 'search_wildcard' },
            'id_prm': { label: 'PRM', mode: 'search_wildcard' },
            'asked_id_prm': { label: 'PRM demandé', mode: 'hidden' },
            'addr_num_street': { label: 'Adresse', mode: 'search_wildcard' },
            'addr_post_code': { label: 'Code postal', mode: 'search_wildcard' },
            'addr_city_lbl': { label: 'Ville', mode: 'hidden' },
            'addr_details': { label: 'Détails', mode: 'hidden' },
            'start_date': { label: 'Date pose', mode: 'search_date' },
            'end_date': { label: 'Date dépose', mode: 'search_date' },
            'extension_date': { label: 'Prolongation', mode: 'search_date' },
            'requester_civ': { label: 'Demandeur civilité', mode: 'hidden' },
            'requester_sn': { label: 'Demandeur nom', mode: 'hidden' },
            'requester_givenname': { label: 'Demandeur prénom', mode: 'hidden' },
            'requester_mail': { label: 'Demandeur mail', mode: 'hidden' },
            'technical_civ': { label: 'Contact civilité', mode: 'hidden' },
            'technical_sn': { label: 'Contact nom', mode: 'hidden' },
            'technical_givenname': { label: 'Contact prénom', mode: 'hidden' },
            'technical_phone': { label: 'Contact téléphone', mode: 'hidden' },
            'technical_mail': { label: 'Contact e-mail', mode: 'hidden' },
            'motivation': { label: 'Motif', mode: 'hidden' },
            'case_code': { label: 'Type de demande', mode: 'hidden' },
            'ticket_link': { label: 'Ticket', mode: 'hidden' },
            'label': { label: 'FTA', mode: 'search_wildcard' },
            'routing_tariff': { label: 'FTA', mode: 'hidden' },
            'voltage_domain': { label: 'Domaine de tension', mode: 'hidden' },
            'max_power': { label: 'Puissance souscrite', mode: 'hidden' },
            'temp_class_powers': { label: 'Puissance par classe temporelle', mode: 'hidden' },
            'phasing': { label: 'Phasage', mode: 'hidden' },
            'id_p_calendar': { label: 'Option tarifaire', mode: 'hidden' },
            'long_usage_context': { label: 'Contexte d\'utilisation', mode: 'hidden' },
            'comments': { label: 'Commentaires', mode: 'search_wildcard' },
            'id_case': { label: 'Affaire', mode: 'search_wildcard' },
            'case.status_code': { label: 'Code statut affaire', mode: 'hidden' },
            'case.status_label': { label: 'Statut affaire', mode: 'search_wildcard' },
            'case.reject_label': { label: 'Rejet affaire', mode: 'hidden' },
            'id_service_order': { label: 'OS envoyé', mode: 'search_wildcard' },
            'contractElec.status': { label: 'Status point', mode: 'search_operator', translate: 'contract_status', translateCsv: 'contract_status' },
        },
        instance: {
            page: () => 1,
            count: () => 25,
            sorting: () => ({ modification_ts: 'desc' }),
            filter: () => ({ status: '!CANCELLED' }),
        },
    }

    if (!$scope.temporaryConnectionsAdmin) {
        delete $scope.temporaryConnections.columns['category.organization']
        delete $scope.temporaryConnections.columns['category.org.type']
    }

    $scope.getCaseStatusClass = (tc) => {
        switch (tc.status_code) {
            case 'TERMN':
                if (tc.reject_label) {
                    return 'red'
                }
                return 'green'
            case 'COURS':
                return 'orange'
            case 'ANNUL':
                return 'grey'
            default:
        }
    }

    OrganizationService.getServiceOrderOrgz().then((serviceOrderOrgz) => {
        $scope.serviceOrderOrgz = serviceOrderOrgz
    })

    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    const refresh = () => TableGeneratorService.getTable($scope.temporaryConnections, 'temporary-connections')

    $scope.isProcessing = (tc) => tc.editing || tc.shooting || tc.cancelling || tc.recycling

    $scope.canEdit = (tc) => {
        return tc.status === 'INITIAL' && !$scope.isProcessing(tc)
    }

    $scope.canShoot = (tc) => {
        return tc.status === 'INITIAL' && tc.id_prm && !$scope.isProcessing(tc)
    }

    $scope.canCancel = (tc) => {
        return tc.status === 'INITIAL'
    }

    $scope.canInitial = (tc) => {
        return tc.status === 'CANCELLED'
    }

    $scope.canRecycle = (tc) => {
        return tc.status === 'DONE'
    }

    $scope.canExtend = (tc) => {
        return tc.status === 'DONE' && tc.case_code === 'F800'
    }

    $scope.expand = function (tc) {
        tc.expanded = !tc.expanded
    }

    $scope.handlesServiceOrder = (tc) => $scope.serviceOrderOrgz.includes(tc.organization)

    $scope.editionTemplate = {
        id_case: '',
        id_prm: '',
        transform: false,
    }

    $scope.editionFields = {
        label: {
            hidden: (template) => !$scope.handlesServiceOrder(template),
            type: 'label',
            label: `<span class="red"><span class="fa fa-warning"></span> Attention, renseigner l'id affaire enverra automatiquement l'ordre de service au coordinateur.</span>`,
        },
        id_case: {
            label: 'Id affaire Enedis',
            type: 'text',
            required: true,
        },
        id_prm: {
            label: 'PRM',
            type: 'text',
        },
        transform: {
            hidden: (template) => !template.id_prm,
            label: 'Tenter la transformation',
            type: 'checkbox',
        },
    }

    $scope.updateTemplate = (tc) => {
        $scope.editionTemplate.id_case = tc.id_case
        $scope.editionTemplate.id_prm = tc.id_prm
        $scope.editionTemplate.transform = !!tc.id_prm
        $scope.editionTemplate.organization = tc.organization
    }

    $scope.extensionTemplate = {
        extension_date: '',
    }

    $scope.extensionFields = {
        extension_date: {
            type: 'date',
            label: `Prolongation`,
            required: true,
        },
    }

    $scope.updateExtensionTemplate = (tc) => {
        $scope.extensionTemplate.extension_date = tc.extension_date
    }

    const updateTc = (tc, payload) => {
        return ApiAdmin.updateTemporaryConnectionRequest({ id: tc.id }, _.omit(payload, ['organization'])).$promise.then((result) => {
            AlertManager[result.eligible !== false ? 'success' : 'error'](result.message, 6000)
            refresh()
        })
        .catch(ErrorCatcher)
    }

    $scope.setInitial = (tc) => {
        tc.initialing = true
        return updateTc(tc, { status: 'INITIAL' })
        .finally(() => {
            tc.initialing = false
        })
    }

    $scope.cancel = (tc) => {
        tc.cancelling = true
        return updateTc(tc, { status: 'CANCELLED' })
        .finally(() => {
            tc.cancelling = false
        })
    }

    $scope.shoot = (tc) => {
        tc.shooting = true
        return updateTc(tc, { transform: true })
        .finally(() => {
            tc.shooting = false
        })
    }

    $scope.edit = (tc) => {
        tc.editing = true
        return updateTc(tc, $scope.editionTemplate)
        .finally(() => {
            tc.editing = false
        })
    }

    $scope.extend = (tc) => {
        tc.extending = true
        return updateTc(tc, $scope.extensionTemplate)
        .finally(() => {
            tc.extending = false
        })
    }

    $scope.recycle = (tc) => {
        tc.recycling = true
        return DataAccess.recycleTemporaryConnection({ id: tc.id }, {}).$promise
        .then((result) => {
            AlertManager.success(`Contrat ${result.contract.id} annulé, et demande de branchement remis à zéro.`)
            refresh()
        })
        .finally(() => {
            tc.recycling = false
        })
    }

    $scope.openTemporaryConnectionModal = () => ModalService.openModal({ type: 'temporaryConnectionModal', size: 'lg' }, { id_account: null }, refresh)

    $scope.refresh = refresh
    refresh()
})
